import DetailRow from "../../../components/UI/viewDialogs/DetailRow";
import { formatDate } from "../../../functions/dateTime/formatDate";
import Modal from "../../../components/portal/Modal";

function CylinderTable({ cylinders = [] }) {
  if (!cylinders.length) {
    return <p className="text-sm text-gray-500">No cylinders</p>;
  }

  return (
    <table className="w-full text-sm border-collapse">
      <thead>
        <tr className="text-left border-b [&_th]:p-1">
          <th>Cylinder No</th>
          <th>Size</th>
          <th>Dispatched On</th>
          <th>Days</th>
        </tr>
      </thead>
      <tbody>
        {cylinders.map((cyl, index) => (
          <tr
            key={cyl.cylinderId}
            className="border-b last:border-0 [&_td]:p-1"
          >
            <td>{cyl.cylinderNo}</td>
            <td>{cyl.size} kg</td>
            <td>{formatDate(cyl.dispatchedFromFactoryAt)}</td>
            <td>{cyl.daysSinceDispatch}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default function IdleCylinderDialog({ viewDetails, setOpenDialog }) {
  const closeDialog = () => {
    setOpenDialog({ openView: false });
  };

  return (
    <Modal modalWidth="view-dialog-content" onClose={closeDialog}>
      <div className="overflow-auto max-h-[80vh] px-2">
        <div className="dialog-sub-title">Station Details</div>
        <div className="view-dialog-content-wrap">
          <DetailRow title="Site" value={viewDetails.stationName} />
          <DetailRow title="Site Id" value={viewDetails.stationId} />
          <DetailRow title="Machine" value={viewDetails.machineId} />
          <DetailRow title="JBCC Field Tech" value={viewDetails.jbccFtName} />
          <DetailRow title="JBCC Supervisor" value={viewDetails.jbccSupName} />
          <DetailRow title="JN Field Tech" value={viewDetails.jnFtName} />
          <DetailRow title="JN Supervisor" value={viewDetails.jnSupName} last="border-none"/>
        </div>

        <div className="dialog-sub-title">
          Filled Cylinders ({viewDetails.filledCylinders?.length ?? 0})
        </div>
        <div className="view-dialog-content-wrap">
          <CylinderTable cylinders={viewDetails.filledCylinders} />
        </div>

        <div className="dialog-sub-title">
          Empty Cylinders ({viewDetails.emptyCylinders?.length ?? 0})
        </div>
        <div className="view-dialog-content-wrap">
          <CylinderTable cylinders={viewDetails.emptyCylinders} />
        </div>
      </div>
    </Modal>
  );
}
